module.exports = __webpack_public_path__ + "static/media/treehouse-home-page-project.59aedf7c.jpg";